import { Icon } from 'common/icon';
import { Routes } from 'constants/routes';

export const navigationBlocksInfo = [
  {
    color: '#01B248',
    icon: <Icon.Balance />,
    identifier: 'Trusted Casinos',
    description:
      'More than 1000 online casinos and more than 17,000 player reviews in the Casinos In Canada rating with real RTP casino games. Watch, read, and then play.',
    ctaText: 'Trusted Casinos',
    href: Routes.casinoCollections('trusted-casinos'),
  },
  {
    color: '#D79B02',
    icon: <Icon.BigWins />,
    identifier: 'Top 10 online casinos',
    description:
      'More than 1000 online casinos and more than 17,000 player reviews in the Casinos In Canada rating with real RTP casino games. Watch, read, and then play.',
    ctaText: 'Top 10 online casinos',
    href: Routes.casinoCollections('top10rtp'),
  },
  {
    color: '#8EAF00',
    icon: <Icon.Wallet />,
    identifier: 'Highest Payouts Casinos',
    description:
      'More than 1000 online casinos and more than 17,000 player reviews in the Casinos In Canada rating with real RTP casino games. Watch, read, and then play.',
    ctaText: 'Highest Payouts Casinos',
    href: Routes.casinoCollections('casino-fastest-payouts'),
  },
  {
    color: '#0584CC',
    icon: <Icon.Details />,
    identifier: 'Casino Ratings',
    description:
      'More than 1000 online casinos and more than 17,000 player reviews in the Casinos In Canada rating with real RTP casino games. Watch, read, and then play.',
    ctaText: 'Casino Ratings',
    href: Routes.casinoCollections('best-casino-apps'),
  },
  {
    color: '#FF2020',
    icon: <Icon.DislikeThird />,
    identifier: 'BlackListed',
    description:
      'More than 1000 online casinos and more than 17,000 player reviews in the Casinos In Canada rating with real RTP casino games. Watch, read, and then play.',
    ctaText: 'BlackListed',
    href: Routes.casinoCollections('trusted-casinos'),
  },
  {
    color: '#7C7C7C',
    icon: <Icon.MessageSecond />,
    identifier: 'Complaints',
    description:
      'More than 1000 online casinos and more than 17,000 player reviews in the Casinos In Canada rating with real RTP casino games. Watch, read, and then play.',
    ctaText: 'Complaints',
    href: Routes.casinoCollections('trusted-casinos'),
  },
];
